import React, { useState, useEffect, useRef, useContext } from 'react'
import "../static/css/Producto/modalCompra.css"
import "animate.css"
import { CartContext } from '../../../providers/CartProvider';

const CompraRapida = ({
  apiUrlState,
  productoCompra,
  setProductoCompra,
  activado,
  setActivado,
  carrito,
  modificarCarritoState,
  actualizarSessionStorage,
}) => {

  const { procomponents, components, addProductToCart } = useContext(CartContext);

  const recursosUrlState = "https://hosting.dkda.com.co/AppWeb";
  const [imgVarianteUrl, setImgVarianteUrl] = useState(""); // Url de la imagen de la variante
  const [selectVariante, setSelectVariante] = useState(null); // Variante seleccionada
  const [tallas, setTallas] = useState([]); // Contiene la lista de tallas de una variante
  const [selectTalla, setSelectTalla] = useState(null); // Talla seleccionada en modal
  const [cantidad, setCantidad] = useState(1); // Cantidad segun talla en el input
  const updateTalla = useRef(true);
  const ruta = useRef(window.location.pathname);

  const cambiarState = () => {
    setActivado(false);
    setCantidad(1);
    setProductoCompra(null);
  }

  const handleVariante = (variante) => {
    setImgVarianteUrl(`${recursosUrlState}/img/Productos/Ref ${variante.Referencia}.webp`);
    setSelectVariante(variante);
    setCantidad(1)
  };

  const changeSelectedTalla = (value, talla) => {
    updateTalla.current = false;
    let temp = tallas;
    setCantidad(1);
    temp = temp.map((element) => {
      return { ...element, estado: value === element.value ? true : false };
    });
    // setCantidad(talla.Cantidad);
    setSelectTalla(talla);
    setTallas(temp);
  };

  const handleCantidad = (accion) => {
    const codigo = selectVariante.Referencia + selectTalla.label;
    const cantidadComp = components.get(procomponents.get(codigo)) || 0;
    if(accion === "add" && cantidad < selectTalla.Cantidad + cantidadComp) {
      setCantidad(cantidad + 1);
    } else if(accion === "sub" && cantidad > 1) {
      setCantidad(cantidad - 1);
    }
  }

  const handleChange = (e) => {
    const value = parseInt(e.target.value);
    if (/^\d{0,3}$/.test(value)) { // Limitar a 3 dígitos
      setCantidad(value);
    }
  };

  /** Una talla estara disponible si su componente esta habilitado */
  const isAvailableSize = (code) => {
    const listComponent = Array.from(procomponents.keys());
    return listComponent.includes(code);
  }

  /** Obtiene las tallas que tienen unidades disponibles o de componente */
  const ObtenerTallas = () => {
    let tallas = [];
    for (let talla of selectVariante.Variantes[0].Tallas) {
      if (talla.Cantidad > 0 || isAvailableSize(selectVariante.Referencia + talla.Talla)) {
        const totalUnidades = talla.Cantidad + Math.max(talla.Componente, 0);
        tallas.push({
          value: talla._id,
          label: talla.Talla,
          image:
          recursosUrlState + "/img/Filtros/" + talla.Talla + "-blanco.webp",
          Cantidad: totalUnidades,
          estado: false,
        });
      }
    }
    setTallas(tallas);
  };


  const addProduct = (variant, size, count) => {
    addProductToCart(variant, size, count);
    setCantidad(1);
  }

  useEffect(() => {
    if(productoCompra !== null) {
      setImgVarianteUrl(`${recursosUrlState}/img/Productos/Ref ${productoCompra[0].Referencia}.webp`);
      setSelectVariante(productoCompra[0]);
      setActivado(true);
    }    
  }, [productoCompra])
  
  useEffect(() => {
    if(selectVariante !== null) {
      ObtenerTallas();
      setSelectTalla(tallas[0])
    }
  }, [selectVariante])

  useEffect(() => {
    if(updateTalla.current) {
      setSelectTalla(tallas[0]);
    }
  }, [tallas])
  
  

  return (
    <>
      {activado ? (
        <div className='modal-compra animated animate__backInDown'>
          <div className='contenedor'>
            <div className='close'>
              <button className='btn-close'
                onClick={cambiarState}
              ><strong>X</strong>
              </button>
            </div>
            <div className='info'>
              <img
              className='img-muestra'
                src={imgVarianteUrl}
                alt={productoCompra[0].RefBase}
                onError={(e) => e.target.src = `${recursosUrlState}/img/General/base2.png`}
              />
              <div>
                <h5>Ref {productoCompra[0].RefBase}</h5>
                {ruta.current==="/Mayoristas"? (
                  <>
                    {productoCompra[0].DescuentoMayorista !== 0? (
                      <>
                        <h6>$ {productoCompra[0].PrecioMayorista}</h6>
                        <h5>$ {productoCompra[0].PrecioMayorista * (1 - productoCompra[0].DescuentoMayorista / 100)}</h5>
                      </>                      
                    ) : (
                      <h5>$ {productoCompra[0].PrecioMayorista}</h5>
                    )}
                  </>
                ) : (
                  <>
                    {productoCompra[0].DescuentoMinorista !== 0? (
                      <>
                        <h6>$ {productoCompra[0].PrecioMinorista}</h6>
                        <h5>$ {productoCompra[0].PrecioMinorista * (1 - productoCompra[0].DescuentoMinorista / 100)}</h5>
                      </>                      
                    ) : (
                      <h5>$ {productoCompra[0].PrecioMinorista}</h5>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="variantes-m">
              <h5 className='title-m'>Colores</h5>
              {productoCompra.map((variante) => (
                <img
                  key={variante.Referencia}
                  alt={productoCompra[0].Referencia}
                  src={`${recursosUrlState}/img/Productos/Ref ` +
                    variante.Referencia + ".webp"}
                  onClick={()=> handleVariante(variante)}
                  onError={(e) => e.target.src = `${recursosUrlState}/img/General/base2.png`}
                />
              ))}
            </div>
            <div className="tallas">
              <h5 className='title-m'>Tallas</h5>
              <div>
                {tallas.map((talla, index) => (
                  <img
                    className=""
                    key={ talla.label + index }
                    alt={talla.label}
                    src={
                      talla.estado
                        ? recursosUrlState + "/img/Filtros/" + talla.label + "-negro.webp"
                        : recursosUrlState +
                          "/img/Filtros/" +
                          talla.label +
                          "-blanco.webp"
                    }
                    id={talla.label}
                    onClick={() => changeSelectedTalla(talla.value, talla)}
                    
                  />
                ))}
              </div>

              <div className="unidades">
                <button onClick={() => {handleCantidad("sub")}}> - </button>
                <input type="number" className='und-input'
                  value={cantidad}
                  onChange={(e) => handleChange(e) }
                />                
                <button onClick={() => {handleCantidad("add")}}> + </button>
              </div>

              <div>
                <button
                  className='addCar'
                  onClick={() => addProduct(selectVariante, selectTalla.label, cantidad) }
                >
                  Agregar al carrito
                </button>
              </div>

            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default CompraRapida;